import React from "react";
import { observer } from "mobx-react-lite";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { GUITextBold, GUIBox, GUIHeadlineLight, GUIHeadlineSuffix } from "./GameUIElements";
import { wrapArraySet, wrapIterator } from "../../../../shared/helper/IterableIteratorWrapper";
import { DialogueParser } from "../DialogueParser";
import { FaFlagCheckered, FaMapMarker } from "react-icons/fa";
import { numberToCSSColor } from "../../../helper/reactHelpers";
import { CgEditBlackPoint } from "react-icons/cg";
import { gameStore } from "../../../stores/GameStore";
import { QuestWindow } from "./NineSlices";
export const QuestContainer = styled.div.withConfig({
  displayName: "QuestlogUI__QuestContainer",
  componentId: "sc-1smzrfr-0"
})(["padding:6px;max-width:300px;margin-bottom:4px;margin-left:4px;"]);
export const TaskTitle = styled.div.withConfig({
  displayName: "QuestlogUI__TaskTitle",
  componentId: "sc-1smzrfr-1"
})(["margin-left:14px;"]);
const QuestIcon = styled(FaFlagCheckered).withConfig({
  displayName: "QuestlogUI__QuestIcon",
  componentId: "sc-1smzrfr-2"
})(["margin-right:8px;"]);
const TaskIcon = styled(CgEditBlackPoint).withConfig({
  displayName: "QuestlogUI__TaskIcon",
  componentId: "sc-1smzrfr-3"
})(["margin-right:6px;"]);
export const QuestlogUI = observer(() => {
  const {
    t
  } = useTranslation();
  const {
    playerQuestLog,
    playerQuestLogTasks
  } = gameStore.gameEngine.gameState;
  const languageKey = gameStore.languageKey;
  const {
    rootActionTree
  } = gameStore.gameEngine;
  return /*#__PURE__*/React.createElement(QuestWindow, null, /*#__PURE__*/React.createElement(GUIHeadlineLight, null, t("game.quest_log"), /*#__PURE__*/React.createElement(GUIHeadlineSuffix, null, "(" + playerQuestLog.size + ")")), /*#__PURE__*/React.createElement(GUIBox, null, wrapArraySet(playerQuestLog).map(questModelId => /*#__PURE__*/React.createElement(QuestContainer, {
    key: questModelId
  }, /*#__PURE__*/React.createElement(GUITextBold, null, /*#__PURE__*/React.createElement(QuestIcon, null), /*#__PURE__*/React.createElement(DialogueParser, {
    dialogueString: rootActionTree.questForId(questModelId).description.get(languageKey),
    initialTreeScopeContext: rootActionTree.questForId(questModelId)
  })), wrapIterator(playerQuestLogTasks.keys()).map(id => rootActionTree.taskForId(id)).filter(task => gameStore.gameEngine.resolvePotentialTreeParameter(task.questId, task) === questModelId).map(task => /*#__PURE__*/React.createElement(TaskTitle, {
    key: task.$modelId
  }, /*#__PURE__*/React.createElement(TaskIcon, null), /*#__PURE__*/React.createElement(DialogueParser, {
    dialogueString: task.description.get(languageKey),
    initialTreeScopeContext: task
  }), task.isTaskWithLocation() && /*#__PURE__*/React.createElement(FaMapMarker, {
    color: numberToCSSColor(playerQuestLogTasks.get(task.$modelId))
  })))))));
});